import { PROJECTS } from "../data/portfolio";

// Temporary name marquee: swap names for logo <img> when the files arrive.
export const ClientMarquee = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {PROJECTS.map((p) => (
        <span key={p.slug} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-3xl text-ink/80 md:px-12 md:text-5xl">{p.title}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-teal" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-ink/10 py-8 md:py-10" data-testid="client-marquee">
      <p className="sr-only">{PROJECTS.map((p) => p.title).join(", ")}</p>
      <div className="flex w-max animate-marquee" aria-hidden="true">
        {row}
        {row}
      </div>
    </div>
  );
};
